import React, { useState } from "react";
import "./styles.css";
import { ReactComponent as SearchSVG } from '../../assets/search.svg';
import {useAudio} from '../context/audio';
import api from '../../api';

export default function SearchForm() {
  const [queryText, setQueryText] = useState("");

  const {audio, setAudio} = useAudio();

  async function search(query) {
    if (query.length > 0) {
      const response = await api.search(query);
      setAudio({
        ...audio,
        id: response.id,
        thumbNail: response.thumbNail,
        title: response.title,
      });
    }
  }

  return (
    <header className='main-header'>
      <form
        className='search-form'
        onSubmit={(e) => {
          e.preventDefault();
          search(queryText);
        }}
      >
        <input
        className='search-input'
        placeholder='Pesquise uma música'
          value={queryText}
          onChange={(e) => {
            setQueryText(e.target.value);
          }}
        />
        <button className='search-button' type="submit">
          <SearchSVG className='search-svg'/>
        </button>
      </form>
    </header>
  );
}
